module.exports = __webpack_public_path__ + "img/bb_g3_leg_01.b8609aea.svg";